exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{-webkit-box-flex:100%;-ms-flex:100% 1 1;flex:100% 1 1;position:relative}.dynamic-scroller-demo,.scroller{height:100%}.XVdatagridheaderDiv,.XVdatagriditemDiv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:5px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.XVdatagridheaderDiv>div,.XVdatagriditemDiv>div{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:left;margin:5px}", ""]);

// exports
